import React, { useEffect, useRef } from "react";

/**
 * Reveal wraps children with a scroll-based fade-up.
 */
export const Reveal = ({ children, delay = 0, className = "", as: Tag = "div", testid }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => e.target.classList.add("in"), delay);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [delay]);

  return (
    <Tag ref={ref} data-testid={testid} className={`reveal ${className}`}>
      {children}
    </Tag>
  );
};

export default Reveal;
